import { DiagramEvent, Iterator, Part, Set } from 'gojs';
import { DataLineageNodeBinding } from '../config/data-lineage-node-bindings';
import { shiftNodes } from './shift-nodes';

export const onSelectionMoved = (event: DiagramEvent, isLatestSnapshot: boolean) => {
  if (!isLatestSnapshot) {
    return;
  }

  const diagram = event.diagram;
  const nodes = event.subject as Set<Part>;

  if (!nodes.count) {
    return;
  }

  // When the user moves the group node, layout must ignore this node when it re-positions its
  // elements (for instance when the dropdown is open)
  nodes
    .filter((node) => node.data.isGroup)
    .each((groupNode) => diagram.model.set(groupNode.data, DataLineageNodeBinding.FixedPosition, true));
};

export const onChangedSelection = (event: DiagramEvent) => {
  const parts = event.subject as Iterator<Part>;
  parts.each((p) => (p.isHighlighted = true));
  if (parts.count === 0) {
    event.diagram.clearHighlighteds();
  }
};

export const onSubGraphExpandChanged = (event: DiagramEvent) => {
  if (event.subject) {
    const groups = event.subject as go.Iterator<go.Group>;
    groups.each((group) => shiftNodes(group));
  }
};
